module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-11.dec61748.mp3";